// role
export enum userRole {
  Admin = "admin",
  SUPER = "super",
}
